import { getAsmSession } from '@/helpers/getAsmSession'

import type { AsmSession } from '@/interfaces/AsmSession'

export function getImpersonatedUser(): AsmSession['impersonatedUser'] {
  return getAsmSession()?.impersonatedUser ?? null
}
